<template>
  <div class='ba-card'>
      <div class='ba-flex ba-jc-sb ba-ai-center ba-w-100'>
          <span class='ba-title'>{{ $t("ct-members-area") }}</span>
      </div>
      <hr class='ba-hr-row'>
      <div class='ba-content ba-w-100'>
          <div class="container-accordion-form ba-grid ba-gp-1" id="accordion">
              <div v-for="(item, index) in items" :key="index" class="container-accordion-form ">
                  <div class="card ba-w-100">
                      <div class="card-header" :class="{'collapsed':!item.expanded}" :id="item.id" @click.prevent="show = item.id"  data-toggle="collapse" :data-target="`#collapse-${item.id}`"
                      :aria-expanded="item.expanded" :aria-controls="`collapse-${item.id}`">
                          <span class="py-1 d-block ba-text-14 ba-montserrat-600" >
                              {{ $t(item.name) }}
                              <font-awesome-icon :icon="['fas', 'chevron-down']" class="font-awesome-icon danger" />
                          </span>
                      </div>
                      <div :id="`collapse-${item.id}`" :aria-labelledby="`${item.id}`" class="collapse" :class="{ 'show': item.expanded }"
                          data-parent="#accordion">
                          <builderall-loader :loading='showLoading' class="ba-w-100 ba-h-100">
                              <div class="card-body ba-w-100">
                                  <component :is="index" v-if="show == item.id" @loading-="setLoading" />
                              </div>
                          </builderall-loader>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import MembersList from '../MembersArea/MembersList.vue';
import Emails from '../Emails.vue'
import Integrations from '../MembersArea/Integrations.vue';

export default {
  components: {
    MembersList,
    Emails,
    Integrations
  },
  data() {
      return {
          items: {
              MembersList: { id: 'members', name: 'ct-members', expanded: true },
              Emails: { id: 'emails', name: 'ct-automatic-emails', expanded: false },
              Integrations: { id: 'integrations', name: 'ct-integrations', expanded: false },
          },
          show: 'members',
          showLoading: false,
      }
  },
  methods: {
      setLoading(value) {
          this.showLoading = value;
      }
  }
}
</script>

<style lang="sass" scoped>

</style>


// WEBPACK FOOTER //
// src/components/dashboard/pages/Members/Members.vue